export class IdPUser {
	id: number;
	idpId:number;
	username: string;
	acctNumber: string;
	firstName: string;
	lastName: string;
	cardId: string;
	phoneNumber: string;
	groupNames: string;
	idpName: string;
	userId: string;
	createdAt: Date;
	updatedAt: Date;
	lastLoginAt: Date;

	constructor(){
		this.id = 0;
		this.idpId = 0;
		this.acctNumber = '';
		this.username = '';
		this.firstName = '';
		this.lastName = '';
		this.cardId = '';
		this.phoneNumber = '';
		this.groupNames = '';
		this.idpName = '';
		this.userId = '';
		this.createdAt = new Date();
		this.updatedAt = new Date();
		this.lastLoginAt = new Date();
	}
}
